import styles from './SubscriptionTable.module.css';

const SubscriptionTable = ({ coachSubscriptions, activeVariantId, onActivate }) => {
    if (!coachSubscriptions || coachSubscriptions.length === 0) {
        return <div className={styles.emptyState}>No subscriptions yet. Browse coaches to choose your first plan.</div>;
    }

    return (
        <div className={styles.list}>
            {coachSubscriptions.map((subscription) => {
                const isActive = subscription.variant_id === activeVariantId;

                return (
                    <article
                        key={subscription.id}
                        className={`${styles.subscriptionCard} ${isActive ? styles.subscriptionCardActive : ''}`}
                    >
                        <div className={styles.subscriptionMeta}>
                            <span className={styles.subscriptionLabel}>Coach</span>
                            <strong>{`${subscription.first_name} ${subscription.last_name}`}</strong>
                            <p>{subscription.name}</p>
                        </div>

                        {isActive ? (
                            <span className={styles.activeBadge}>Active</span>
                        ) : (
                            <button
                                onClick={() => onActivate(subscription.variant_id)}
                                className={styles.button}
                                type="button"
                            >
                                Use this plan
                            </button>
                        )}
                    </article>
                );
            })}
        </div>
    );
};

export default SubscriptionTable;
